import { Link } from "react-router-dom";
import './footer.scss'

export default function Footer() {

  return (
    <>
      <footer className="main-footer">
        <div className="footer-top">
          <div className="container">

            <div className="footer-grid">

              <div className="footer-col">
                <h4>Company</h4>
                <p>At GWCS, we are dedicated to providing outstanding service to our clients while fostering a culture of continuous learning and professional excellence for our employees.</p>
                <ul className="social-links">
                  <li>
                    <a href="/">
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>

                  <li>
                    <a href="/">
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>

                  <li>
                    <a href="/">
                      <i className="bx bxl-instagram"></i>
                    </a>
                  </li>

                  <li>
                    <a href="/">
                      <i className="bx bxl-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-col">
                <h4>Useful Links</h4>
                <ul>
                  <li><Link to="about">About Us</Link></li>
                  <li><a href="#">FAQs</a></li>
                  <li><Link to="contact">Contact Us</Link></li>
                </ul>
              </div>

              <div className="footer-col">
                <h4>Our Services</h4>
                <ul>
                  <li><Link to="/">Tour & Travel Solutions</Link></li>
                  <li><Link to="/">Mobile & Web Application Development</Link></li>
                  <li><Link to="/">Digital Marketing</Link></li>
                  <li><Link to="/">IT Services & Consulting</Link></li>
                </ul>
              </div>

              <div className="footer-col">
                <h4>Support</h4>
                <ul>
                  <li><Link to="/">Technical Support</Link></li>
                  <li><Link to="/">FAQs</Link></li>
                  <li><Link to="/">Support & Maintenance</Link></li>
                </ul>
              </div>


            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">

            <div className="footer-bottom-row">
              <p className="copyright m-0">
                © 2026 Genius World. All rights reserved.
              </p>
              <div className="footer-links">
                <Link to="/terms-condition">Terms & Conditions</Link>
                <Link to="/privacy-policy">Privacy</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>

    </>
  )
}
